import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, delay, map, mergeMap, of, retry, tap, expand, timer, EMPTY } from 'rxjs';

import { Budget, BudgetImport } from '@/organisations/models';
import { PollingStatus } from '@/tax/models';

import { environment } from '@env';

const DELAY_STATUS_FETCH_MS = 5000;

const invalidErrorMessage = 'Not ready';

@Injectable({
    providedIn: 'root',
})
export class BudgetService {
    constructor(private http: HttpClient) { }

    createBudgetImportAndPollResult(orgId: number, companyId: number, budgetImport: BudgetImport): Observable<BudgetImport> {
        return this.createBudgetImport(orgId, companyId, budgetImport).pipe(
            expand((sync) => {
                if (sync.status === PollingStatus.Init || sync.status === PollingStatus.InProgress) {
                    return timer(2000).pipe(
                        mergeMap(() => this.getBudgetImport(orgId, companyId, sync.id))
                    );
                }
                return EMPTY;
            })
        );
    }

    getBudgetImport(orgId: number, companyId: number, budgetImportId: number): Observable<BudgetImport> {
        return this.http
            .get<any>(environment.endpoints.organisationCompaniesBudgetImportsDetails(orgId, companyId, budgetImportId))
            .pipe(map<any, BudgetImport>((budgetImport) => new BudgetImport().deserialize(budgetImport)));
    }

    createBudgetImport(orgId: number, companyId: number, budgetImport: BudgetImport): Observable<BudgetImport> {
        return this.http
            .post<BudgetImport>(environment.endpoints.organisationCompaniesBudgetImportsList(orgId, companyId), budgetImport.serialize())
            .pipe(map((sync) => new BudgetImport().deserialize(sync)));
    }

    getBudgets(orgId: number, companyId: number): Observable<Budget[]> {
        return this.http
            .get<any>(environment.endpoints.organisationCompaniesBudgetList(orgId, companyId))
            .pipe(map<any, Budget[]>((budgets) => budgets.map((d: Budget) => new Budget().deserialize(d))));
    }
}
